import React from 'react';
import {FirebaseImage as BaseFirebaseImage} from '@embertracking/ui/components';

import {storage} from '-/firebase';
import {protectedFileClient} from '-/data/protectedFiles';

export default function FirebaseImage(props) {
    return <BaseFirebaseImage fileClient={protectedFileClient} storage={storage} {...props} />;
}
